import React from 'react'

const MaleSweeps = (props) => (
		<div className="fineryCard whiteCard" style={props.swipeStyle} >
			<div className="womanLandscape">
				<h3>WHAT YOU THINK IS WORTH A LOT!</h3>
        <span>
          <strong>$500</strong> to be exact. You could win all that
  				cash PLUS a styling session with <strong>Brooklyn</strong> <strong>Decker</strong> and the experts at <strong>Finery</strong>!
        </span>
        <div className="fineryEmailField">
        <form onSubmit={props.handleSubmit}>
          <button type="submit" ></button>
          <input type="text" name="" placeholder="example@email.com" value={props.InputValue} onChange={props.handleChange} />
        </form>
        </div>
			</div>
		</div>
)
export default MaleSweeps;



// WEBPACK FOOTER //
// ./src/templates/MaleSweeps.js